module.exports = __webpack_public_path__ + "static/textarea-label-dont-e73697a91d7170e725edc7e9e4e36f9c.png";